import formatDate from './format-date';

export default function(dateObj, isRange = true) {
  if (isRange) {
    if (dateObj && dateObj.from) {
      return {
        filterByStartDate: formatDate(dateObj.from),
        filterByEndDate: formatDate(dateObj.to),
      };
    }

    return {
      filterByStartDate: formatDate(dateObj),
      filterByEndDate: formatDate(dateObj),
    };
  }

  return {
    filterByDate: formatDate(dateObj),
  };
};
